import { useEffect, useState, Fragment } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Grid,
    IconButton,
    Toolbar,
    Typography,
    useMediaQuery,
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import DeleteIcon from '@material-ui/icons/Delete';
import { Edit } from '@material-ui/icons/';
import { makeStyles } from '@material-ui/core/styles';
import { host } from "../../../data";
import TankTemplateForm from './TankTemplateForm';
import { Auth } from 'aws-amplify';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    indented: {
        marginLeft: theme.spacing(10),
    },
    grow: {
        flexGrow: 1,
    },
    content: {
        padding: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    dialogForm: {
        fullWidth: 'true',
        maxWidth: 'lg'
    },
    formControlLabel: {
        marginLeft: theme.spacing(2),
    },
    rootpaper: {
        width: 1000,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        overflowX: "auto"
    },
    dropdown: {
        display: 'flex',
        marginLeft: 'auto',
    },
    templatetable: {
        width: '100%',
        height: '50vh',
        zIndex: 0,
        border: 0,
    },
    table: {
        width: '100%',
        height: '72vh',
    },
    link: {
        color: theme.palette.info.dark,
    },
}));

const TankTemplatesManagement = ({ orgInfo, templates, setTemplates }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:600px)');
    const [openAddTemplate, setOpenAddTemplate] = useState(false);
    const [deleteTemplateTarget, setDeleteTemplateTarget] = useState({});
    const [openDeleteTemplate, setOpenDeleteTemplate] = useState(false);
    const [editTemplateTarget, setEditTemplateTarget] = useState({});
    const [editTemplateTargetId, setEditTemplateTargetId] = useState(0);
    const [openTemplateEdit, setOpenTemplateEdit] = useState(false);
    const [newTemplate, setNewTemplate] = useState({});
    const [calculatedMaxCapacity, setCalculatedMaxCapacity] = useState();
    const [templateCol, setTemplateCol] = useState([]);
    const templateColumns = [
        {
            headerName: t('templateName'),
            field: 'name',
            flex: 1,
            disableClickEventBubbling: true
        },
        {
            headerName: t('edit'),
            field: 'Edit',
            renderCell: renderTemplateEdit,
            flex: 1,
            sortable: false,
            disableClickEventBubbling: true
        },
        {
            headerName: t('delete'),
            field: 'Delete',
            renderCell: renderDeleteTemplate,
            flex: 1,
            sortable: false,
            disableClickEventBubbling: true
        },
    ];

    useEffect(() => {
        setTemplateCol(templateColumns);
    }, []);

    useEffect(() => {
        if (matches) {
            setTemplateCol(prevState => prevState.map((el, index) => {
                const { flex, ...rest } = el;
                if (index === 0) {
                    return { ...rest, width: 140 }
                }
                return { ...rest, width: 120 };
            }));
        }
    }, [matches]);

    function validateData(input) {
        console.log(input);
        var ret = 1;
        var tankName = input.Name;
        var selectedTankShape = input.Params[0].TankShape;
        var tankHeight = input.Params[0].TankHeight;
        var tankCapacity = input.Params[0].TankCapacity;
        var fillCapacity = input.Params[0].FillCapacity;
        var tankDiameter = input.Params[0].TankDiameter;
        var tankLength = input.Params[0].TankLength;
        var tankWidth = input.Params[0].TankWidth;
        var levelVolumeTable = input.StrappingTable;

        if (!tankName) {
            alert(t("templateNameIncomplete"));
            ret = 0;
        }

        if ("vertical" === selectedTankShape) {
            if (!tankHeight) {
                alert(t("tankHeightInvalid"));
                ret = 0;
            } else if (parseFloat(tankHeight) < 1) {
                alert(t("tankHeightMustBeGreaterThan0"))
                ret = 0;
            }

            if (!tankCapacity) {
                alert(t("tankCapacityInvalid"));
                ret = 0;
            }

            if (parseFloat(fillCapacity) > parseFloat(tankCapacity)) {
                alert(t("fillCapcityExceeds"));
                ret = 0;
            }

            if (parseFloat(fillCapacity) < 1) {
                alert(t("fillCapacityMustBeGreaterThan0"));
                ret = 0;
            }
        }

        if ("horizontal" === selectedTankShape) {
            if (!tankDiameter) {
                alert(t("tankDiameterInvalid"));
                ret = 0;
            } else if (parseFloat(tankDiameter) < 1) {
                alert(t("tankDiameterMustBeGreater"));
                ret = 0;
            }

            if (!tankLength) {
                alert(t("tankLengthInvalid"));
                ret = 0;
            } else if (parseFloat(tankLength) < 1) {
                alert(t("tankLengthMustBeGreater"));
                ret = 0;
            }

            if (parseFloat(fillCapacity) > calculatedMaxCapacity) {
                alert(t("fillCapcityExceeds"));
                ret = 0;
            }

            if (parseFloat(fillCapacity) < 1) {
                alert(t("fillCapacityMustBeGreater"));
                ret = 0;
            }
        }

        if ("obround" === selectedTankShape) {
            if (!tankHeight) {
                alert(t("tankHeightInvalid"));
                ret = 0;
            } else if (parseFloat(tankHeight) < 1) {
                alert(t("tankHeightMustBeGreaterThan0"));
                ret = 0;
            }

            if (!tankLength) {
                alert(t("tankLengthInvalid"));
                ret = 0;
            } else if (parseFloat(tankLength) < 1) {
                alert(t("tankLengthMustBeGreaterThan0"));
                ret = 0;
            }

            if (!tankWidth) {
                alert(t("tankWidthInvalid"));
                ret = 0;
            } else if (parseFloat(tankWidth) < 1) {
                alert(t("tankWidthMustBeGreater"));
                ret = 0;
            }

            if (parseFloat(fillCapacity) > calculatedMaxCapacity) {
                alert(t('fillCapcityExceeds'));
                ret = 0;
            }
            if (parseFloat(fillCapacity) < 1) {
                alert(t("tankWidthMustBeGreater"));
                ret = 0;
            }
        }

        if ("table" === selectedTankShape) {
            if (levelVolumeTable.length === 0) {
                ret = 0;
                console.log(levelVolumeTable);
                alert(t("enterStrappingTable"));
            } else {
                if (parseInt(fillCapacity) > levelVolumeTable[levelVolumeTable.length - 1].volume) {
                    alert(t("fillCapacityExceedsTankCapacity"));
                    console.log("Fill Capacity exceeds tank Capacity (highest volume in table)");
                }

                for (var i = 0; i < levelVolumeTable.length - 1; i++) {
                    if (levelVolumeTable[i].volume > levelVolumeTable[i + 1].volume) {
                        ret = 0;
                        alert(t("tableVolumeValuesMustIncrease"))
                        break;
                    }

                    if (levelVolumeTable[i].volume < 0) {
                        //First entry must be zero.  So zero is valid.
                        ret = 0;
                        alert(t("tableVolumeValuesMustNotBeNegative"));
                    }
                }
            }
        }
        return ret;
    };

    const handleOpenDeleteTemplate = (target) => {
        setDeleteTemplateTarget(target);
        setOpenDeleteTemplate(true);
    };

    const handleCloseDeleteTemplate = () => {
        setOpenDeleteTemplate(false);
    };

    function renderDeleteTemplate(params) {
        var bdisable = false;
        return (
            <IconButton edge="end" aria-label="delete" disabled={bdisable} onClick={() => handleOpenDeleteTemplate(params.row)}>
                <DeleteIcon />
            </IconButton>
        );
    };

    const handleTemplateDelete = () => {
        var delete_id = deleteTemplateTarget.id;
        handleCloseDeleteTemplate(false);

        Auth.currentAuthenticatedUser()
            .then(data => {
                var body = JSON.stringify(
                    {
                        "id": delete_id
                    }
                );

                var requestOptions = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                    body: body
                };

                fetch(host + '/orgs/' + orgInfo.orgId + '/templates/' + delete_id, requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        console.log(data);
                        if (data.error === "OK") {
                            setTemplates(data.templatesList);
                        }
                        else {
                            alert(data.error);
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
            });
    };

    const handleOpenEditTemplate = (target) => {
        setOpenTemplateEdit(true);
        setEditTemplateTarget(target);
        setEditTemplateTargetId(target.id);
    };

    const handleCloseTemplateEdit = () => {
        setOpenTemplateEdit(false);
    };

    function renderTemplateEdit(params) {
        return (
            <IconButton edge="end" aria-label="edit" onClick={() => handleOpenEditTemplate(params.row)}>
                <Edit />
            </IconButton>
        );
    };

    const handleTemplateEdit = () => {
        var lnewTemplate = editTemplateTarget;

        if (validateData(lnewTemplate)) {
            setOpenTemplateEdit(false);

            Auth.currentAuthenticatedUser()
                .then(data => {

                    var body = JSON.stringify(
                        lnewTemplate
                    );

                    var requestOptions = {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body
                    };

                    fetch(host + '/orgs/' + orgInfo.orgId + '/templates/' + editTemplateTargetId, requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            console.log(data);
                            if (data.error === "OK") {
                                setTemplates(data.templatesList);
                            }
                            else {
                                alert(data.error);
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                });
        }
    };

    const handleOpenAddTemplate = () => {
        setOpenAddTemplate(true);
        setNewTemplate({});
    };

    const handleCloseAddTemplate = () => {
        setOpenAddTemplate(false);
    };

    const handleAddTemplate = () => {
        var lnewTemplate = newTemplate;
        if (validateData(lnewTemplate)) {
            setOpenAddTemplate(false);

            Auth.currentAuthenticatedUser()
                .then(data => {
                    var body = JSON.stringify(
                        lnewTemplate,
                    );

                    var requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body
                    };

                    fetch(host + '/orgs/' + orgInfo.orgId + '/templates', requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            if (data.error === "OK") {
                                setTemplates(data.templatesList);
                            }
                            else {
                                alert(data.error);
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                });
        }
    };

    return (
        <Fragment>
            <Grid item xs>
                <Toolbar>
                    <Typography variant='h6'>
                        {t("templates")}
                    </Typography>
                    <div className={classes.grow} />
                    <Button className={classes.content} onClick={handleOpenAddTemplate} variant="contained" color="primary">
                        {t("addTemplate")}
                    </Button>
                </Toolbar>
            </Grid>
            <Grid item xs>
                <div className={classes.templatetable}>
                    <DataGrid hideFooterSelectedRowCount
                        rowsPerPageOptions={[25, 50, 100]}
                        pagination
                        pageSize={50}
                        rows={templates}
                        columns={templateCol} />
                </div>
            </Grid>

            <Dialog fullWidth='true' maxWidth='lg' disableBackdropClick disableEscapeKeyDown open={openTemplateEdit} onClose={handleCloseTemplateEdit}>
                <DialogTitle>{t("editTemplate") + ' '}{editTemplateTarget.name}</DialogTitle>
                <DialogContent>
                    <TankTemplateForm template={editTemplateTarget} setTemplateData={setEditTemplateTarget} setCalculatedMaxCapacity={setCalculatedMaxCapacity} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseTemplateEdit} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button onClick={handleTemplateEdit} variant="contained" color="primary">
                        {t("save")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog disableBackdropClick disableEscapeKeyDown open={openDeleteTemplate} onClose={handleCloseDeleteTemplate}>
                <DialogTitle>{t('deleteTemaplte') + ' '}{deleteTemplateTarget.name}</DialogTitle>
                <DialogContent>
                    <Typography>{t("areYouSure")}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteTemplate} variant="contained" color="secondary">
                        {t("cancel")}
                    </Button>
                    <Button onClick={handleTemplateDelete} color="primary">
                        {t("delete")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth='true' maxWidth='lg' disableBackdropClick disableEscapeKeyDown open={openAddTemplate} onClose={handleCloseAddTemplate}>
                <DialogTitle>{t("newTemplate")}</DialogTitle>
                <DialogContent>
                    <TankTemplateForm template={newTemplate} setTemplateData={setNewTemplate} setCalculatedMaxCapacity={setCalculatedMaxCapacity} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddTemplate} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button onClick={handleAddTemplate} variant="contained" color="primary">
                        {t("save")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export default TankTemplatesManagement;